import { useSyncExternalStore } from 'react';
import { getImpersonationModule } from './install';
export function useImpersonationEmail() {
    const module = getImpersonationModule();
    return useSyncExternalStore((listener) => module.subscribe(listener), () => module.getEmail(), () => module.getEmail());
}
